<template>
  <v-container pa-0>
    <v-row>
      <div class="page__title">
        <div>
          <h1>Ustawienia</h1>
        </div>
      </div>
    </v-row>

    <active-card v-if="isCardActive" />

    <v-row>
      <v-col cols="12" md="10" lg="8" xl="6">
        <v-form>
          <profile-form v-if="schemaLoaded" :schema="$schema">
            <v-row slot="actions" class="mx-0">
              <v-col cols="6" offset="6" class="pr-0">
                <v-btn large color="primary" width="100%" elevation="0" :disabled="!isOnline" @click="tryToUpdate">
                  Zapisz
                </v-btn>
              </v-col>
            </v-row>
          </profile-form>
        </v-form>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="10" lg="8" xl="6">
        <change-password-form />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { schemaMixin } from '@witkac/vuetify-components';

import ChangePasswordForm from '@/components/forms/ChangePasswordForm';
import ProfileForm from '@/components/forms/ProfileForm';
import ActiveCard from '@/components/settings/ActiveCard';
import { LocalStorage } from '@/enums/storage.enum';
import { connectionMixin } from '@/mixins/connection';
import { cardMixin } from '@/mixins/cardMixin';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/edit.schema';

// @vuese
// Edycja danych profilowych
// @group Settings
export default {
  components: { ChangePasswordForm, ProfileForm, ActiveCard },
  mixins: [schemaMixin, connectionMixin, cardMixin, notificationsMixin],
  data() {
    return {
      model: {
        profile: {
          terc: '221201',
          simc: '0977427',
          type: 'CLIENT',
          woj: 'pomorskie',
          pow: 'powiat słupski',
          gmi: 'gmina miejska Ustka',
          postalCode: '76-270'
        }
      },
      schemaLoaded: false,
      prevRoute: null
    };
  },
  schema,
  computed: mapState({ profile: state => state.profile.data, application: state => state.application }),
  created() {
    this.$schema.$setData({ profile: this.profile });
    this.schemaLoaded = true;
  },
  methods: {
    // @vuese
    // Próba aktualizacji danych profilu
    tryToUpdate() {
      if (!this.$schema.$validateAll().length) {
        const id = parseInt(localStorage.getItem(LocalStorage.PROFILE_ID));
        this.$store
          .dispatch('profile/update', { ...this.model.profile, id })
          .then(() => {
            this.notifySuccess('Zapisano zmiany w profilu.');
            if (this.prevRoute?.name === 'application') {
              this.$router.push({ name: 'application' });
            }
          })
          .catch(() => this.notifyError('Nie udało się zapisać zmian w profilu.'));
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
};
</script>
